const maintenanceData = {
  mlog: {
    op: {
      enter_maintenance: 'メンテナンス閲覧',
      successful_login: 'ログイン成功',
      failed_login: 'ログイン失敗',
      logout: 'ログアウト',
      navigate: '画面遷移 ({arg1} → {arg2})',
      restart_service: 'サービス開始',
      stop_service: 'サービス停止',
      print_receipt: 'レシート印刷 ({arg1}) ',
      restart_device: '再起動',
      open_volume_settings: '音量設定',
      open_brightness_settings: '明るさ設定',
      open_network_settings: 'ネットワーク設定',
      create_admin: '管理者の設定 (新規登録: {arg1})',
      modify_admin: '管理者の設定 (設定変更: {arg1})',
      remove_admin: '管理者の設定 (削除: {arg1})',
      change_billbox: '金庫回収・交換',
      power_off: '電源オフ',
      reset_shop_settings: '店舗情報の再取得',
      disable_device: '機器を無効化 {arg1}',
      enable_device: '機器を有効化 {arg1}',
      set_device_driver: '{arg1}のドライバを{arg2}に設定',
      set_timezone: 'タイムゾーンを {arg1} に設定',
      enable_currency: '通貨を有効化 {arg1}',
      disable_currency: '通貨を無効化 {arg1}',
      disable_ethernet: 'LANケーブル接続を無効化',
      enable_ethernet_static: 'LANケーブル接続を有効化, 固定IPアドレスを入力',
      enable_ethernet_dynamic: 'LANケーブル接続を有効化, DHCPを使用',
      disable_wifi: 'WiFi接続を無効化',
      enable_wifi_static: 'WiFi接続を有効化, 固定IPアドレスを入力, SSID: {arg1}',
      enable_wifi_dynamic: 'WiFi接続を有効化, DHCPを使用, SSID: {arg1}',
      change_accepted_bills: '受け入れ紙幣金種を変更',
      edit_fees: '両替手数料レートを変更する',
      set_charge_method: 'チャージモードを{arg1}に設定',
      set_member_app_url: 'アプリのインストールURLを設定',
    },
    device: {
      printer: 'プリンタ',
      billval: 'ビルバリ',
      camera: 'カメラ',
      nfc: 'NFC',
    },
  },
  receipt_type: {
    successful_transactions: '正常取引履歴',
    failed_transactions: 'エラー取引履歴',
    maintenance_log: '作業履歴',
    test_print: 'テスト',
  },
};

const errorData = {
  errors: {
    fs: 'ファイルシステムにエラーが発生しました',
    power_loss: '電源の喪失がありました',
    keymanager: 'API認証情報の読み込みに失敗しました',
    network: 'ネットワークエラー',
    network_outage: 'ネットワークがありません',
    printer: 'プリンタに問題があります',
    stacker_full: '金庫の空き容量がありません',
    cheated: '紙幣受け入れ機が不正な操作を検出しました',
    jammed: '紙幣が詰まりました',
    cassette_not_attached: '金庫が正しくセットされていません',
    no_response: '紙幣識別ユニットの接続を確認して下さい',
    billval: '紙幣受け入れ機エラー',
    subboard: 'QR/NFCモジュールとの接続に失敗しました',
    printer_out_of_paper: 'プリンタ用紙がありません',
    printer_jam: '紙詰まりが置きています。',
    printer_head_open: 'プリンタのカバーヘッドが開いています',
    door: 'ドアセンサーエラー',
    power: 'DC電源スイッチエラー',
    no_hardware_settings: '店舗設定がありません',
    internal: '内部エラー',
    device_sdk_error: 'システムドライバエラー',
    api: 'APIエラー',
    could_not_change_app_environment: '環境の変化を出来ません',
    channel: {
      send: '通信エラー(Send)',
      recv: '通信エラー(Recv)',
    },
    db_error: 'データベースエラー',
    unconfigured: '設定されていません',
    update_failed: 'アップデートに失敗しました',
    timeout: 'タイムアウト',
    indeterminate: '処理未了',
    startup: '起動中にエラーが発生しました ',
    dialog: {
      could_not_open_network_settings: 'ネットワーク設定が開けませんでした',
      could_not_reboot_device: '再起動できませんでした',
      cannot_show_admin_list: 'エラー: 管理者を表示できません',
      billval_note_update_failed: '紙幣情報の更新に失敗しました',
      unacceptable_bill: '{bill} の紙幣は投入できません',
      printer_not_connected: 'プリンターが接続されていません、 オフになります',
    },
    time_zone_setting: '時間帯を変化出来ません',
  },
};

const parseData = (rawData, dataUsing) => {
  const keys = rawData.split('.');

  if (keys.length === 1) {
    return rawData;
  }

  const access = (obj, key) => (!!obj && obj[key]) || '';

  return keys.reduce(access, dataUsing) || rawData;
};

const parseErrorData = (error) => parseData(error, errorData);

const parseMaintentanceData = (maintenance) => {
  const { operation } = maintenance;

  const p = parseData(operation, maintenanceData);

  return Array(4)
    .fill()
    .map((_, i) => `arg${i + 1}`)
    .reduce(
      (acc, arg) =>
        maintenance[arg]
          ? acc.replace(`{${arg}}`, parseData(maintenance[arg], maintenanceData))
          : acc,
      p
    );
};

export { errorData, maintenanceData, parseData, parseErrorData, parseMaintentanceData };
